import { Autocomplete, Box, TextField } from "@mui/material";
import { countries } from "pages/commons/constants";

interface CountrySelectProps {
  countryChange: (code?: string) => void;
  country?: string;
  labelText?: string;
  isSendAction?: boolean;
}

export const CountrySelect = ({
  countryChange,
  country,
  labelText = "Select your country",
  isSendAction = false,
}: CountrySelectProps) => {
  const getCountryDisplay = (code?: string) => {
    if (code) {
      return countries.find((c) => c.code === code);
    }
    console.log("isSendAction: ", isSendAction);
    console.log("country: ", country);
  };
  return (
    <Autocomplete
      id="country-select-demo"
      options={countries}
      autoHighlight
      onChange={(_, item) => countryChange(item ? item.code : undefined)}
      value={getCountryDisplay(country)}
      getOptionLabel={(option) => option.label}
      renderOption={(props, option) => {
        const { key, ...optionProps } = props;
        return (
          <Box
            key={option.code}
            component="li"
            sx={{ "& > img": { mr: 2, flexShrink: 0 } }}
            {...optionProps}
          >
            <img
              loading="lazy"
              width="20"
              srcSet={`https://flagcdn.com/w40/${option.code.toLowerCase()}.png 2x`}
              src={`https://flagcdn.com/w20/${option.code.toLowerCase()}.png`}
              alt=""
            />
            {option.label} ({option.code}) +{option.phone}
          </Box>
        );
      }}
      renderInput={({ inputProps, ...params }) => (
        <TextField
          {...params}
          inputProps={{ ...inputProps, readOnly: true, style: { minWidth: 0 } }}
          label={labelText}
          required
          error={isSendAction && !country}
        />
      )}
    />
  );
};
